import merge from 'lodash/merge';
import { TFunction } from 'i18next';
import customConfig from 'src/config';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,
import { ApplyBoundEnum } from '../utils/types';
import { convertTreeData } from './cfg.exchange';
import cloneDeep from 'lodash/cloneDeep';

const cfg = {
  policyType: 1,
  policySubType: 0,
  holderType: 2,
};

export function getDlpExchangeTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}

export function getDlpConfig(
  t: TFunction<'translation'>,
  currentOrgGlobalSetting: any,
  templateConfig: any
) {
  const originConfig: any = {
    limitation: cloneDeep(customConfig.ui.policy.limitation),
    fileTypes: cloneDeep(customConfig.ui.policy.fileTypes),
    featureShow: cloneDeep(customConfig.ui.policy.featureShow),
    validTokenList: cloneDeep(customConfig.ui.policy.validTokenList),
    defaultValue: {
      tmDpfilters: {
        dpReplacementText: templateConfig.tmDpfilters?.dpReplacementText,
      },
      tmKeywordfilters: {
        kfReplacementText: templateConfig.tmKeywordfilters?.kfReplacementText,
      },
    },
    exchangeOnlineApplyBoundOptions: [
      ApplyBoundEnum.sentMessageOnly,
      ApplyBoundEnum.all,
    ],
  };

  originConfig.fileTypes = convertTreeData(customConfig.ui.policy.fileTypes, t);
  const config = {
    ...originConfig,
    limitation: {
      ...originConfig.limitation,
      blockedListMaxCount: currentOrgGlobalSetting?.blockSenderMaxCount
        ? parseInt(currentOrgGlobalSetting?.blockSenderMaxCount as string)
        : originConfig.limitation.blockedListMaxCount,
      blockedUrlMaxCount: currentOrgGlobalSetting?.blockUrlMaxCount
        ? parseInt(currentOrgGlobalSetting?.blockUrlMaxCount as string)
        : originConfig.limitation.blockedUrlMaxCount,
      approvedListMaxCount: originConfig.limitation.approvedListMaxCount,
      asApprovedSenderMaxCount: currentOrgGlobalSetting?.approvedSenderMaxCount
        ? parseInt(currentOrgGlobalSetting?.approvedSenderMaxCount as string)
        : originConfig.limitation.approvedListMaxCount,
    },
    featureShow: {
      ...originConfig.featureShow,
      urlSandboxFeatureShow: !!currentOrgGlobalSetting.urlSandboxFeatureShow,
      activeContentSanitizingExceptionListFeatureShow:
        !!currentOrgGlobalSetting?.activeContentSanitizingExceptionListFeatureShow,
      vaTempQuarantineEnabled:
        !!currentOrgGlobalSetting?.ddaTempQuarantineFeatureShow,
      aggressiveNameSpoofing: !!currentOrgGlobalSetting?.aggressiveNameSpoofing,
      gmailQtSettingFeatureShow:
        !!currentOrgGlobalSetting?.gmailQtSettingFeatureShow,
    },
  };
  console.log(config);
  return originConfig;
}
